import { createContext, ReactNode, useState } from 'react'
import { Position } from 'types'
import UgeCrop from '../types/crop'

type ContextProps = {
    crop?: Position
    cropType: UgeCrop
    setCrop: (crop?: Position) => void
    setCropType: (type: UgeCrop) => void
}

type Props = {
    children?: ReactNode
    defaultCrop?: Position
}

export const UgeCropContext = createContext({} as ContextProps)

const UgeCropContextManager = ({ children, defaultCrop }: Props) => {
    const [crop, setCrop] = useState<Position | undefined>(defaultCrop)
    const [cropType, setCropType] = useState<UgeCrop>('custom')

    return (
        <UgeCropContext.Provider value={{ crop, cropType, setCrop, setCropType }}>{children}</UgeCropContext.Provider>
    )
}

export default UgeCropContextManager
